(function () {
  'use strict';

  var zone = document.querySelector('[data-product-zone]');
  var form = zone && zone.querySelector('form[action*="/cart/add"]');
  if (!form || !(zone.matches('[data-wheel-product]') || zone.querySelector('[data-wheel-build]'))) return;
  var params = new URLSearchParams(window.location.search);
  var saved = params.get('wheel_build');
  var style = String(params.get('wheel_style') || '').slice(0, 180);
  if (saved === null || !style) return;

  var config;
  var changes = [];
  var valid = saved.length <= 3000;
  try { config = valid ? JSON.parse(saved) : null; } catch (error) { config = null; }
  if (!config || typeof config !== 'object' || Array.isArray(config)) valid = false;
  var options = valid && config.options !== undefined ? config.options : {};
  var properties = valid && config.properties !== undefined ? config.properties : {};
  if (!options || typeof options !== 'object' || Array.isArray(options) || !properties || typeof properties !== 'object' || Array.isArray(properties)) valid = false;

  var fieldsets = Array.prototype.slice.call(zone.querySelectorAll('[data-option-fieldset]'));
  var optionNames = valid ? Object.keys(options) : [];
  var hasOptionPreset = optionNames.length > 0;
  if (valid && hasOptionPreset && optionNames.length !== fieldsets.length) valid = false;
  if (valid) {
    (hasOptionPreset ? fieldsets : []).forEach(function (fieldset) {
      var name = String(fieldset.getAttribute('data-option-name') || '').toLowerCase();
      var key = optionNames.find(function (optionName) { return optionName.toLowerCase() === name; });
      var value = key && options[key];
      var input = typeof value === 'string' && Array.prototype.find.call(fieldset.querySelectorAll('input[type="radio"]'), function (radio) {
        return radio.value === value && !radio.disabled;
      });
      if (!input) valid = false;
      else changes.push({ field: input, radio: true });
    });
    Object.keys(properties).forEach(function (property) {
      var value = properties[property];
      // Only real product dropdowns can be prefilled; vehicle details and confirmations are entered by the buyer.
      var field = Array.prototype.find.call(form.querySelectorAll('select[name]'), function (select) {
        return select.name === 'properties[' + property + ']' && !select.disabled;
      });
      var matches = field && typeof value === 'string' && Array.prototype.some.call(field.options, function (option) {
        return option.value === value && !option.disabled;
      });
      if (!matches) valid = false;
      else changes.push({ field: field, value: value });
    });
  }

  var notice = document.createElement('div');
  notice.className = 'pdp__style-context' + (valid ? '' : ' is-error');
  notice.setAttribute('role', 'status');
  var title = document.createElement('strong');
  title.textContent = style;
  var explanation = document.createElement('p');
  explanation.textContent = valid
    ? 'Selected build options are shown below. Enter your exact car details; compatibility is confirmed before production.'
    : 'The saved style options do not match this product. Select your build options below, or ask us to confirm this style before ordering.';
  notice.appendChild(title);
  notice.appendChild(explanation);
  form.insertBefore(notice, form.firstChild);

  if (valid) {
    // Validate everything before changing anything, so a bad link never applies half a build.
    changes.forEach(function (change) {
      if (change.radio) change.field.checked = true;
      else change.field.value = change.value;
    });
    changes.forEach(function (change) { change.field.dispatchEvent(new Event('change', { bubbles: true })); });
    var styleProperty = document.createElement('input');
    styleProperty.type = 'hidden';
    styleProperty.name = 'properties[Selected wheel style]';
    styleProperty.value = style;
    form.appendChild(styleProperty);
  } else {
    // A malformed preset requires an explicit choice instead of retaining the product's default variant.
    fieldsets.forEach(function (fieldset) {
      fieldset.querySelectorAll('input[type="radio"]').forEach(function (radio) { radio.checked = false; });
    });
    if (fieldsets.length) {
      var first = fieldsets[0].querySelector('input[type="radio"]');
      if (first) first.dispatchEvent(new Event('change', { bubbles: true }));
      var atc = zone.querySelector('[data-atc]');
      if (atc && !atc.disabled) {
        atc.removeAttribute('aria-disabled');
        atc.textContent = atc.getAttribute('data-pick-label') || 'Pick your options';
      }
    }
  }
  zone.dispatchEvent(new Event('minkmods:purchase-update'));
  if (window.location.hash === '#WheelBuildOptions') {
    requestAnimationFrame(function () { form.scrollIntoView({ block: 'start' }); });
  }
})();
